import {IInterceptor, intercept, isObservableArray, IValueWillChange, toJS} from "mobx";
import {StoreControl} from "../../controls/base/StoreControl";
import 'reflect-metadata';
import {observe} from "mobx";

export abstract class StoreBase {

    IsDirty:boolean=false;
    private _fields:StoreControl<any,any>[]=[];
    private _defaultValuesLoaded:boolean;
    constructor()
    {
        this._defaultValuesLoaded=false;
    }
    public AddField(field:StoreControl<any,any>){
        this._fields.push(field);
    }

    public RemoveField(field:StoreControl<any,any>)
    {
        let index=this._fields.indexOf(field);
        if(index>=0)
            this._fields.splice(index,1);
    }

    public Observe(propertyName:string,callBacks:(params:any)=>void):()=>void{

        let internalCallBack=()=>{callBacks(this[propertyName]);};
        let event=new MobXObserveEvent();

        event.mainSubscription=observe(this as any,propertyName,(e)=>{
            internalCallBack();
            this.ObserveSubProperties(e.newValue,internalCallBack,event);
        });
        this.ObserveSubProperties(this[propertyName],internalCallBack,event);
        return event.Unsubscribe.bind(event);
    }

    private ObserveSubProperties(object:any,internalCallBack:any,eventManager:MobXObserveEvent){
        eventManager.SubElementsUnsubscribe();
        if(object==null||typeof object.$mobx =="undefined")
            return;
        for(let subProperty in object.$mobx.values)
        {
            eventManager.subElements.push(observe(object,subProperty,(e)=>{
                internalCallBack();
            }));

        }
    }

    public GetValue(property:keyof this|any)
    {
        return this[property];
    }

    public SetValue(property:keyof this|any,value:any)
    {
        return this.ParseAndSetValue(property,value);
    }

    protected abstract LoadDefaultValues();

    public Merge<K extends keyof this>(itemToLoad:Partial<this>|any=null){
        if(!this._defaultValuesLoaded) {
            this.LoadDefaultValues();
            this._defaultValuesLoaded=true;
        }
        if(itemToLoad==null) {
            return this;
        }
        for(let propertyName in itemToLoad)
        {
            if((this as any).hasOwnProperty(propertyName))
            {
                let value:any=itemToLoad[propertyName];
                this.ParseAndSetValue(propertyName,value);

            }

        }

        return this;
    }

    private ParseAndSetValue(propertyName,value:any){
        let currentValue=this[propertyName];
        let loaderValue=this.GetValueFromLoader(propertyName,value);
        if(loaderValue!=null)
        {
            (this as any)[propertyName]=loaderValue;
            return;
        }

        if(currentValue!=null&& currentValue.LoadDefaultValues!=null) {
            if(value!=null&&value.hasOwnProperty('_fields')&&value.hasOwnProperty('_defaultValuesLoaded'))
                (this as any)[propertyName]=value;
            else
                (this as any)[propertyName].Merge(value);
            return;
        }

        if(typeof currentValue=='number') {
            (this as any)[propertyName] = parseFloat(value.toString());
            return;
        }

        if(typeof currentValue=='boolean')
        {
            if(!isNaN(value))
                (this as any)[propertyName]=value===true||parseFloat(value)==1;
            else
                (this as any)[propertyName]=value=='true';
            return;
        }


        if(typeof currentValue=='string')
        {
            (this as any)[propertyName]=value;
            return;
        }

        if(currentValue!=null&& currentValue.constructor==Array||isObservableArray(currentValue))
        {
            let type=(Reflect as any).getMetadata(StoreKey,this,propertyName) as typeof StoreBase;
            if(type==null)
                throw 'Property '+propertyName+' of class '+(this as any).constructor.name+' is an array but does not have the OptionType decorator implemented';

            (this[propertyName] as any)=[];
            if((type as any)==String)
            {
                this[propertyName]=value;
                return;
            }


            if((type as any)==Number)
            {
                this[propertyName]=value;
                return;
            }
            for(let newValueItem of value)
            {
                  if(newValueItem!=null&&newValueItem.hasOwnProperty('_fields')&&newValueItem.hasOwnProperty('_defaultValuesLoaded'))
                    (this[propertyName] as any).push(newValueItem);
                else
                    (this[propertyName] as any).push(new (type as any)().Merge(newValueItem));
			}

            return;
        }

        let type=(Reflect as any).getMetadata(StoreKey,this,propertyName) as any;
        if(type==Object)
        {
            this[propertyName]=value;
            return;
        }



        throw 'Could not process type '+ typeof currentValue+' of '+propertyName;
    }

    protected GetValueFromLoader(property:keyof this,value:any):any
    {
        return null;

    }


    public Validate(){
        let isValid=true;
        for(let field of this._fields)
        {
            if(!field.Validate())
                isValid=false;
        }

        return isValid;
    }


    public ToObject(){
       let object=toJS(this);
       return this.SerializeObject(object);
    }

    public Subscribe(propertyName:keyof this,callback:IInterceptor<IValueWillChange<any>>)
    {
        return intercept(this,propertyName,callback);

    }


    private SerializeObject(object: this):any {
        let fieldsToRemove=['_fields','_defaultValuesLoaded','IsDirty'];

        for(let property in object)
        {
            let item=object[property];
            if(fieldsToRemove.indexOf(property)>=0||typeof item=='function') {
                delete object[property];
                continue;
            }

            if(Array.isArray(item))
            {
                this.SerializeArray(item);
            }

            if(typeof item=='object')
            {
                item=this.SerializeObject(item as any);
            }

        }

        return object;
    }

    private SerializeArray(array: any[]) {
            for(let i=0;i<array.length;i++)
            {
                let item=array[i];
                if(Array.isArray(item))
                    this.SerializeArray(item);

                if(typeof item =='object')
                    array[i]=this.SerializeObject(item);
            }
    }
}



const StoreKey='StoreType';
export function StoreDataType(type:typeof StoreBase|object) {
    return (Reflect as any).metadata(StoreKey,type);
}


export class MobXObserveEvent{
    public mainSubscription:()=>void;
    public subElements:(()=>void )[]=[];
    Unsubscribe(){
        this.mainSubscription();
        this.SubElementsUnsubscribe();
    }

    public SubElementsUnsubscribe(){
        if(this.subElements==null)
            return;
        for(let subelement of this.subElements)
        {
            subelement();
        }

        this.subElements=[];
    }


}